// Product List
const productList = {
  tabList: [
    { en_cate_name: "All" },
  ]
}


// Product Detail
const productDetail = {
  label1: 'Specification and model',
  label2: 'Comprehensive information',
  label3: 'Performance characteristics',
  label4: 'Product advantage',
  label5: 'Structural characteristics',
  label6: 'Sample download',
  label7: 'Associated actuators',
  label8: 'Associated modified valve',
  label9: 'Can be used in combination with the following actuators:',
  label10:'Associate the following modified valves:'
}

const onlineMessage = {
  info_list: [
    {
      label: "Email：",
      content: "info@kelkflow.com.cn"
    },
    {
      label: "Phone/Wechat：",
      content: "+86-13951576318(China)"
    },
    {
      label: "Phone/WhatsApp：",
      content: "+1-7788738683(0versea)"
    },
   /*  {
      label: "",
      content: `
        <div style="color: #00335a;margin-top:-10px;">
          (Working hours: Monday to Friday, 8:00 am - 4:30 PM)
        </div>
      `
    }, */
  ],
  qrcode: [
    { label: '', src: require("@/assets/images/callMe/qrIcon.png"), }
  ]
}


export default {
  title: 'Product Center',
  subTitle: 'KELK Product Center',
  text1: 'Sleeve guided single-seat regulating valve',
  searchTitle: '$count products related to "$keywords”" are found',
  searchPlaceholder: 'Please enter the keyword',
  searchListTitle: 'Product search',
  searchTip: 'Tip: Please enter the product name or model',
  // Product List
  productList,
  // Product Detail
  productDetail,
  onlineMessage,
}


// WEBPACK FOOTER //
// ./src/config/lang/en/productCenterPage.js